import React, { useState } from 'react';
import moment from 'moment';
import Status from '../../../shared/Status/Status';
import { getTranslation } from '../../../../utils/translation';
import { renderVoucherStatusName } from '../../../../utils/render';
import { VOUCHER_STATUSES } from '../../../../constants/enums';
import { changeVoucherModalProps } from '../../../../store/actions/vouchers';
import { useDispatch } from 'react-redux';

const dateTimeFormat = 'DD/MM/YYYY HH:mm:ss';

export default function Table(props) {
    const { vouchers } = props;
    const dispatch = useDispatch();

    const getStatusTheme = statusName => {
        switch (statusName) {
            case VOUCHER_STATUSES.active:
                return 'success';
            case VOUCHER_STATUSES.inactive:
                return 'danger';
            case VOUCHER_STATUSES.cancelled:
                return 'neutral';
            default:
                return '';
        }
    };

    const onDetailsClick = voucherCode => {
        dispatch(changeVoucherModalProps({ isVisible: true, voucherCode }));
    };

    return (
        <table className={'point-table'}>
            <thead>
                <tr align='center'>
                    <th>{getTranslation('voucherTableNoColumn')}</th>
                    <th>{getTranslation('voucherTableStatusColumn')}</th>
                    <th>{getTranslation('voucherTableIdColumn')}</th>
                    <th>{getTranslation('voucherTableCashierCodeColumn')}</th>
                    <th>{getTranslation('voucherTableTerminalCodeColumn')}</th>
                    <th>{getTranslation('voucherTableCreateDateColumn')}</th>
                    {/*<th>{getTranslation('voucherTableIssueDateColumn')}</th>*/}
                    <th>{getTranslation('voucherTableExpireDateColumn')}</th>
                    <th>{getTranslation('voucherTableAmountDateColumn')}</th>
                    {/*<th />*/}
                </tr>
            </thead>
            <tbody>
                {vouchers.map((voucher, index) => (
                    <tr align='center' key={index}>
                        <td className='td-number'>{index + 1}</td>
                        <td>
                            <Status
                                status={getStatusTheme(voucher.status)}
                                title={renderVoucherStatusName(voucher.status)}
                            />
                        </td>
                        <td>{voucher.id}</td>
                        <td>{voucher.cashierCode}</td>
                        <td>{voucher.terminalCode}</td>
                        <td>{moment(voucher.createdAt).format(dateTimeFormat)}</td>
                        {/*<td>*/}
                        {/*    {voucher.issuedAt*/}
                        {/*        ? moment(voucher.issuedAt).format(dateTimeFormat)*/}
                        {/*        : '-'}*/}
                        {/*</td>*/}
                        <td>{moment(voucher.expiredAt).format(dateTimeFormat)}</td>
                        <td>{voucher.amount} AZN</td>
                        <td>
                            <button
                                className='detailsBtn'
                                onClick={() => onDetailsClick(voucher.code)}
                            >
                                <span>{getTranslation('ticketsTableDetailsButton')}</span>
                                <span className='icon-arrow-down' />
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
}
